import { render, staticRenderFns } from "./CompareTheMarketLogo.vue?vue&type=template&id=e4e59298&scoped=true"
import script from "./CompareTheMarketLogo.vue?vue&type=script&lang=js"
export * from "./CompareTheMarketLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e59298",
  null
  
)

export default component.exports